import { Component, Inject, Prop, Ref } from "vue-property-decorator";
import renderUtils from "@/components/RenderUtils";
import MergeHooks from "@/decorators/mergeHooks";
import getLang from "@/components/RenderUtils/utils/lang";
import getStyles from "@/components/RenderUtils/utils/style";
import { getUserInfo } from "@/utils/auth";
import { unFlatTreeData } from "@/components/RenderUtils/utils";
import CurdForm from "@/components/BaseCurd/form";
import { MasterlinkTenantServiceProxy, AuthorityDomainServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
import { CalendarServiceProxy } from "@/service-proxies/app-v2/time.service-proxies";
import {
  tranformTreeShape,
  tranformOptionsShape,
  noop,
} from "@/components/RenderUtils/utils/index";
import {
  WorkStationServiceProxy,
  WorkStationGroupServiceProxy,
  WorkStationSettingServiceProxy,
} from "@/service-proxies/app-v2/workStation.service-proxies";
import { TransferDirectoryQueryServiceProxy } from "@/service-proxies/app-v2/dnc.service-proxies";
import { Types, Codes, ACLS } from "@/components/RenderUtils/utils/constants";
import R from "ramda";
import dayjs from "dayjs";
import { CodeRuleServiceProxy } from "@/service-proxies/app-v2/code.service-proxies";
const mtsp = new MasterlinkTenantServiceProxy();
const workStationService = new WorkStationServiceProxy();
const authorityDomainService = new AuthorityDomainServiceProxy();
const calendarService = new CalendarServiceProxy();
const wsgsp = new WorkStationGroupServiceProxy();
const wsssp = new WorkStationSettingServiceProxy();
const directoryService = new TransferDirectoryQueryServiceProxy();
const crsp = new CodeRuleServiceProxy();

@Component({
  CurdForm,
})
@MergeHooks
export default class ProductInfo extends renderUtils {
  @Inject() readonly refresh!: any;
  @Ref() readonly formRef!: CurdForm;
  @Prop({ default: () => Types.edit }) readonly type: any;
  @Prop({ default: () => {} }) readonly sourceData: any;
  @Prop({ default: () => true }) readonly showHeader: boolean;

  groups = [];
  copyData = {};
  showCopyModal = false;
  showCalendarModal = false;
  tenantName = "";
  val = "";

  calendarData = {};
  calendarList = [];
  visable = false;
  typeList =[ {
    label: "空",
    value: 0,
  },
  {
    label: "机器",
    value: 1,
  },
  {
    label: "人工",
    value: 2,
  },];
  typeName = "";
  deptList = [];
  deptName = "";
  groupNames = "";
  groupIds= [];
  groupsList = [];

  get lang() {
    return getLang(this);
  }

  get editdata() {
    return this.type === Types.edit ? this.sourceData : {};
  }



  async created() {
    let getPageCalendar = calendarService.getPageCalendar.bind(calendarService)
    const { records } = await getPageCalendar({ statusList: [1] }, 1, -1)
    this.calendarList = records
  }

  getChange(val) {
    // console.log("val", val);
    this.visable = !!val;
    this.formRef.form.setFieldsValue({["code"]:""})
    // console.log(11111,this.formRef.form.getFieldValue('code'))
  }

  get copySchema() {
    return {
      "workStationInfo.type": {
        label: this.lang.station_type,
        type: "select",
        placeholder: this.$t('please_select')as string + this.lang.station_type,
        rules: [
          {
            required: true,
            message: this.lang.station_type_required,
          },
        ],
        options: [
          {
            label: "空",
            value: 0,
          },
          {
            label: "机器",
            value: 1,
          },
          {
            label: "人工",
            value: 2,
          },
        ],
      },
      "workStationInfo.code": {
        label: this.lang.station_no,
        type: "input",
        placeholder: this.$t('common_please_input')as string + this.lang.station_no,
        rules: [
          {
            required: true,
            message: this.lang.station_no_required,
          },
        ],
      },
      "workStationInfo.name": {
        label: this.lang.station_name,
        type: "input",
        placeholder: this.$t('common_please_input')as string + this.lang.station_name,
        rules: [
          {
            required: true,
            message: this.lang.station_name_required,
          },
        ],
      },
      "workStationInfo.deptId": {
        label: this.lang.authority_jurisdiction,
        type: "treeSelect",
        placeholder: this.$t('please_select')as string + this.lang.authority_jurisdiction,
        props: {
          allowClear: true,
          showSearch:true,
          treeNodeFilterProp:"title"
        },
        options: async () => {
          const { data } = await authorityDomainService.getEnableTreeList();
          return R.pipe(R.prop(0), tranformTreeShape, R.of)(data);
        },
      },
      "workStationInfo.calendarCode": {
        label: this.lang.station_calendar,
        type: "select",
        placeholder: this.$t('please_select')as string + this.lang.station_calendar,
        props: {
          allowClear: true,
        },
        options: () =>
          R.pipe(
            calendarService.getPageCalendar.bind(calendarService),
            R.andThen(
              R.pipe(
                R.prop("records"),
                tranformOptionsShape((data, to) => {
                  return {
                    [to]: data.code + "-" + data.name,
                  };
                }, "id")
              )
            )
          )({ statusList: [1] }, 1, -1),
      },
      "workStationInfo.groupId": {
        label: this.lang.station_group,
        type: "treeSelect",
        placeholder: this.$t('please_select')as string + this.lang.station_group,
        props: {
          allowClear: true,
          multiple: true,
        },
        options: this.groups,
      },
      "workStationInfo.standardEfficiency": {
        label: this.$t('page_workStation_standard_efficiency'),
        type: "inputNumber",
        placeholder: this.$t('common_please_input')as string + this.$t('page_workStation_standard_efficiency'),
        props: {
          min:0,
          max:100,
          formatter: value => `${value}%`
        },
      },
      "workStationInfo.yieldRatio": {
        label: this.$t('page_plan_yield_ratio'),
        type: 'inputNumber',
        placeholder: this.$t('common_please_input') as string + this.$t('page_plan_yield_ratio'),
        props: {
          min: 1,
          formatter: value => Number(value).toFixed(0)
        },
      },
      "workStationInfo.internalStorage": {
        label: this.$t('page_dnc_station_file_internal_storage'),
        type: "switch",
      },
      transferId: {
        type: "select",
        placeholder: this.$t('please_select')as string + this.$t("page_workstation_maintain_transport_directory"),
        label: this.$t("page_workstation_maintain_transport_directory"),
        options: async () => {
          const data = await directoryService.list("0");
          return tranformOptionsShape("name", "id")(data);
        },
      },
    };
  }

  getChangeType(val) {
    let type = this.typeList.find(item =>item.value === val)
    this.typeName = type.label
    // console.log(1111,this.typeName)
  }

  get schema() {
    const isCreate = this.type === Types.create;
    const dynamicType = isCreate ? "input" : "text";
    const readonly = !isCreate && !this.hasAcl(ACLS.EDIT_WORKSTATION);
    const hasCalendar =
      this.editdata.calendarCode !== null &&
      this.editdata.calendarCode !== undefined &&
      this.editdata.calendarCode !== "";
    const defaultYieldRatio = isCreate ? {defaultValue: 1} : {}

      let temp = {
        type: {
          label: this.lang.station_type,
          type: isCreate ? "select" : "text",
          placeholder: this.$t('please_select')as string + this.lang.station_type,
          rules: [
            {
              required: true,
              message: this.lang.station_type_required,
            },
          ],
          on: {
            change: this.getChangeType,
          },
          customRender: (text) => Codes[text],
          options: [
            {
              label: "空",
              value: 0,
            },
            {
              label: "机器",
              value: 1,
            },
            {
              label: "人工",
              value: 2,
            },
          ],
        },
        codeRuleId: {
          label: this.$t("page_system_coding_rules"),
          type: "select",
          placeholder: this.$t('please_select')as string + this.$t("page_system_coding_rules"),
          props: {
            allowClear: true,
            placeholder: this.$t("page_system_select_coding_rule"),
            maxLength: 128,
          },
          options: async () => {
            const list = await crsp.list("WorkStationObject");
            // console.log("qqqqqqq",data)
            return list.map((item) => ({ label: item.name, value: item.id }));
          },
          on: {
            change: this.getChange,
          },
          // onClick: this.getList(),
        },
        code: {
          label: this.lang.station_no,
          type: dynamicType,
          placeholder: this.$t('common_please_input')as string + this.lang.station_no,
          props: {
            disabled: this.visable
          },
          rules: [
            {
              required: !this.visable,
              message: this.lang.station_no_required,
            },
          ],
        },
        name: {
          label: this.lang.station_name,
          type: "input",
          placeholder: this.$t('common_please_input')as string + this.lang.station_name,
          rules: [
            {
              required: true,
              message: this.lang.station_name_required,
            },
          ],
          on: {
            blur: (e) => {
              const cb = () => this.refresh.lists();
              return this.getModifyFunc("name", cb)(e.target.value);
            },
          },
        },
        deptId: {
          label: this.lang.authority_jurisdiction,
          type: "treeSelect",
          disabled: readonly,
          placeholder: this.$t('please_select')as string + this.lang.authority_jurisdiction,
          props: {
            allowClear: true,
            showSearch:true,
            treeNodeFilterProp:"title"
          },
          on: {
            change: (val)=>this.getModifyFunc("deptId", val)(val),
          },
          options: async () => {
            const { data } = await authorityDomainService.getEnableTreeList();
            this.deptList = R.pipe(R.prop(0), tranformTreeShape, R.of)(data)
            return R.pipe(R.prop(0), tranformTreeShape, R.of)(data);
          },
        },
        calendarCode: {
          label: this.lang.station_calendar,
          placeholder: this.$t('please_select')as string + this.lang.station_calendar,
          type: this.type === Types.edit && hasCalendar ? "text" : "select",
          disabled: readonly,
          props: {
            allowClear: true,
          },
          customRender: (value) => {
            let msg;
            if(value!=0){
              msg =<span>{value}</span>
            }
            return (
              <div style={getStyles("flex")}>
                {msg}
                <a-button type="link" onClick={this.openCalendarModal}>
                  {this.$t("page_workstation_maintain_change_calendar")}
                </a-button>
              </div>
            );
          },
          on: {
            change: (val) =>this.getModifyFunc("calendarCode",val)(val),
          },
          options: () =>
            R.pipe(
              calendarService.getPageCalendar.bind(calendarService),
              R.andThen(
                R.pipe(
                  R.prop("records"),
                  tranformOptionsShape((data, to) => {
                    return {
                      [to]: data.code + "-" + data.name,
                    };
                  }, "id")
                )
              )
            )({ statusList: [1] }, 1, -1),
        },
        groupId: {
          label: this.lang.station_group,
          type: "treeSelect",
          placeholder: this.$t('common_please_input')as string + this.lang.station_group,
          disabled: readonly,
          props: {
            allowClear: true,
            multiple: true,
          },
          on: {
            change: this.modifyGroupId,
            deselect:this.delectSelect,
          },
          options: this.groups,
        },
        standardEfficiency: {
          label: this.$t('page_workStation_standard_efficiency'),
          type: "inputNumber",
          placeholder: this.$t('common_please_input')as string + this.$t('page_workStation_standard_efficiency'),
          props: {
            min:0,
            max:100,
            formatter: value => `${value}%`
          },
          on: {
            blur: (e) => {
              const cb = () => this.refresh.lists();
              return this.getModifyFunc("standardEfficiency", cb)(e.target.value.replace('%', ''));
            },
          },
        },
        yieldRatio: {
          ...defaultYieldRatio,
          label: this.$t('page_plan_yield_ratio'),
          type: 'inputNumber',
          placeholder: this.$t('common_please_input') as string + this.$t('page_plan_yield_ratio'),
          props: {
            min: 1,
            formatter: value => value ? Number(value).toFixed(0) : 1
          },
          on: {
            blur: (e) => {
              const cb = () => this.refresh.lists()
              return this.getModifyFunc('yieldRatio', cb)(e.target.value)
            }
          }
        },
        internalStorage: {
          label: this.$t('page_dnc_station_file_internal_storage'),
          type: "switch",
          on: {
            change: (val) =>this.getModifyFunc("internalStorage",val)(val),
          },
        },
      }
    let keys = ['type','code','name','deptId','calendarCode','groupId', 'standardEfficiency', 'yieldRatio']
    let value = {}
    if(this.$store.getters.buttons.includes('page_workstaion_maintain_internalStorage')){
      keys.push('internalStorage')
    }
    if(!this.showHeader) {
      keys.splice(1,0,'codeRuleId')
    }
    keys.map(k=>{
      value[k] = temp[k]
    })
    console.log(value)
    return value
  }

  get calendarSchema() {
    return {
      calendarCode: {
        type: "text",
        label: this.$t("page_workstation_maintain_current_calendar"),
      },
      waitingUpdateCalendar: {
        label: (this.calendarData as any).waitingUpdateCalendar
          ? this.$t("page_workstation_maintain_will_change")
          : this.$t("page_workstation_maintain_change_new_calendar"),
        type: "select",
        options: () =>
          R.pipe(
            calendarService.getPageCalendar.bind(calendarService),
            R.andThen(
              R.pipe(
                R.prop("records"),
                tranformOptionsShape((data, to) => {
                  return {
                    [to]: data.code + "-" + data.name,
                  };
                }, "id")
              )
            )
          )({ statusList: [1] }, 1, -1),
      },
    };
  }

  render() {
    /*生产工位信息面板*/
    const { station_info } = this.lang;
    return (
      <blank-view
        style={getStyles("margBtm8")}
        bodyStyle={getStyles("wrapper")}
        mainStyle={getStyles("transparent")}
      >
        <p
          style={getStyles("pHeader", "flex", "between")}
          v-show={this.showHeader}
        >
          <span>{station_info}</span>
          <a-button type="primary" onClick={this.openCopyModal}>
            {this.$t("page_workstation_maintain_copy_workstation")}
          </a-button>
        </p>
        <CurdForm
          ref="formRef"
          formProps={{
            labelAlign: "left",
          }}
          resetLayout={'3:3:3'}
          footer={false}
          type="edit"
          schema={this.schema}
          defaultValue={this.editdata}
        />
        {this.renderCopyModal()}
        {this.renderCalendarModal()}
      </blank-view>
    );
  }

  async mounted() {
    const qr = mtsp.queryRole(getUserInfo().tenant_id);
    const {
      data: { tenantName },
    } = await qr;
    this.tenantName = tenantName;
    await this.loadGroups();
  }

  openCalendarModal() {
    const today = dayjs();
    if (today.hour() == 23 && today.minute() >= 30) {
      this.$message.error(
        this.$t("page_workstation_maintain_change_calendar_tips")
      );
      return;
    }

    const { waitingUpdateCalendar, calendarCode } = this.sourceData;
    this.calendarData = {
      waitingUpdateCalendar: waitingUpdateCalendar,
      calendarCode: calendarCode,
    };
    this.showCalendarModal = true;
  }

  async openCopyModal() {
    console.log('this.sourceData:', this.sourceData)
    const {
      waitingUpdateCalendar,
      calendarCode,
      code,
      id,
      deptId,
      groupId,
      name,
      type,
      standardEfficiency,
      internalStorage,
      yieldRatio
    } = this.sourceData;

    const {
      transferDirectoryId,
    } = await wsssp.workStationTransferSettingDetail(id);
    this.copyData = {
      originalWorkStationId: id,
      transferId: transferDirectoryId || "",
      workStationInfo: {
        calendarCode,
        code,
        deptId,
        groupId: [].concat(groupId),
        name,
        type,
        standardEfficiency,
        waitingUpdateCalendar,
        internalStorage,
        yieldRatio
      },
    };
    this.showCopyModal = true;
  }

  renderCopyModal() {
    const props = {
      title: this.$t("page_workstation_maintain_copy"),
      show: this.showCopyModal,
      schema: this.copySchema,
      ok: this.submitCopy,
      cancel: () => (this.showCopyModal = false),
      editdata: this.copyData,
      footer: "default",
      ref: "copy",
    };

    return this.renderDialogWithForm(props);
  }

  /*保存更换的新日历*/
  async submitCalendar(is_cancel = false) {
    let data;
    if (is_cancel) {
      data = {
        waitingUpdateCalendar: undefined,
      };
    } else {
      data = await (this.$refs.calendar as any).manualSubmit();
    }
    const merge = {
      ...this.sourceData,
      ...data,
    };

    let params = {
      ...merge,
      waitingUpdateCalendar: this.getCalendarCodeById(merge.waitingUpdateCalendar)
    }
    await workStationService.updateWorkStation(R.omit(["id"], params), merge.id);
    this.$message.success(this.$t("save_success"));
    this.showCalendarModal = false;
    this.refresh.productInfo();
  }

  /*编辑工位里的日历弹框*/
  renderCalendarModal() {
    const append = (
      <a-button-group style="width:200px">
        {(this.calendarData as any).waitingUpdateCalendar ? (
          <a-button
            style="margin-right:10px"
            onClick={() => this.submitCalendar(true)}
          >
            {this.$t("page_workstation_maintain_cancel_update")}
          </a-button>
        ) : null}
        <a-button type="primary" onClick={() => this.submitCalendar()}>
          {this.$t("save")}
        </a-button>
      </a-button-group>
    );
    // console.log('editdata:', this.calendarData)
    if(this.calendarData['calendarCode']==0){
      this.calendarData['calendarCode']=' '
    }
    let temp = {
      ...this.calendarData,
      waitingUpdateCalendar: this.getCalendarIdByCode((this.calendarData as any).waitingUpdateCalendar)
    }
    const props = {
      title: this.$t("page_workstation_maintain_change_calendar"),
      show: this.showCalendarModal,
      schema: this.calendarSchema,
      cancel: () => (this.showCalendarModal = false),
      editdata: temp,
      ref: "calendar",
      footer: append,
    };
    return this.renderDialogWithForm(props);
  }

  async submitCopy(data) {
    await workStationService.copyWorkStationInfo(data);
    this.$message.success(this.$t("page_workstation_maintain_copy_success"));
    this.refresh.lists();
    this.showCopyModal = false;
  }

  delectSelect(val) {
    this.groupIds.forEach((item,i) =>{if (item ===val ) {
      return this.groupIds.splice(i,1)
    }})
    // console.log(444,this.groupIds)
  }
  async modifyGroupId(groupId) {
    this.groupNames = ""
    this.groupIds = groupId;
    groupId.forEach((element) => {
      if (element === "0") {
        this.groupNames = this.tenantName
      }
      let code = this.groupsList.find((item) =>
             item.id === element
      );
      if(code&&code.hasOwnProperty('name'))
      this.groupNames = this.groupNames +","+ code.name
    });
    // console.log(11111,names)
      // console.log(11111,this.groupNames)
    if (this.type !== Types.edit) return;
    await wsgsp.insertWorkStationToGroup({
      groupId: groupId,
      workStationId: this.editdata.id,
    } as any);

    this.$message.success(this.lang.modify_success);
  }

  async loadGroups() {
    const { workStationGroupDTOList: data } = await wsgsp.list();
    this.groupsList = data;
    const treeData = unFlatTreeData()(data, (item) => ({
      label: item.name,
      value: item.id,
    }));
    this.groups = [
      {
        label: this.tenantName,
        value: "0",
        children: treeData,
      },
    ] as any;
  }

  forName(item) {
    if(item.value === this.val)
    this.deptName = item.label
     if(item&&item.hasOwnProperty('children'))
     if(item.children.length>0)
     item.children.find(items =>{this.forName(items)})
    // console.log(11111,this.deptName)
  }

  /*编辑工位信息*/
  getModifyFunc(key,val,callback?) {
    if (key === "deptId") {
      this.val =val
      this.deptList.find(item =>{this.forName(item) })
    }
    const cb = () => {
      this.$message.success(this.lang.modify_success);
      if (callback) callback();
    };
    const fetchModify = R.curry(
      workStationService.updateWorkStation.bind(workStationService)
    )(R.__, this.editdata.id);
    return R.propEq("type", Types.edit, this)
      ? R.pipe(
          (value) => {
            this.editdata[key] = value || "";
            if(key==='calendarCode') {
              this.editdata[key] = this.getCalendarCodeById(this.editdata[key])
            }
            if(key==='internalStorage'){
              this.editdata[key] = val
            }
            console.log("编辑提交：", this.editdata)
            return R.omit(["id"], this.editdata);
          },
          fetchModify,
          R.andThen(cb)
        )
      : noop;
  }

  /*新增工位*/
  submit() {
    return this.formRef
      .manualSubmit()
      .then((data:any) => {
        let params = Object.assign({}, data, {calendarCode: this.getCalendarCodeById(data.calendarCode)})
        params.typeName = this.typeName
        params.deptName = this.deptName
        params.groupNames = this.groupNames
        console.log('提交新建工位表单：=========》', params)
        return workStationService.createWorkStation(params);
      })
      .then((data) => {
        console.log(1111, data)
        return data.id;
      });
  }

  hasAcl(acl) {
    return this.$store.getters.buttons.includes(acl);
  }

  /*根据日历id获取日历code*/
  getCalendarCodeById(id) {
    let item = this.calendarList.find(item=>item.id===id)
    return item ? item.code : ''
  }

  /*根据日历code获取日历id， 当code有重复项时则选中第一个对应的日历id*/
  getCalendarIdByCode(code) {
    let item = this.calendarList.find(item=>item.code===code)
    return item ? item.id : ''
  }
}
